import actions from './actions';
import { createReducer } from '../../helpers/reducer';
import { t } from '../../i18n';

const initialState = {
  notifications: [],
};

function onAddNotification(state = initialState, { payload }) {
  const { id, type, message, headline } = payload;
  const newNotification = {
    id,
    type: type || 'info',
    message,
    headline,
  };

  return {
    ...state,
    notifications: [...state.notifications, newNotification],
  };
}

function onRequestError(state = initialState, { payload }) {
  const { id, error, message } = payload;
  const errorNotification = {
    id,
    type: 'error',
    message: error || message,
    headline: t('dash.common.notification.error_headline'),
  };

  return {
    ...state,
    notifications: [...state.notifications, errorNotification],
  };
}

function onDismissNotification(state = initialState, { payload }) {
  const idx = state.notifications.findIndex(notification => notification.id === payload);

  if (idx >= 0) {
    return {
      ...state,
      notifications: [...state.notifications.slice(0, idx), ...state.notifications.slice(idx + 1)],
    };
  }

  return state;
}

export default createReducer(initialState, {
  [actions.ADD_NOTIFICATION]: onAddNotification,
  [actions.DISMISS_NOTIFICATION]: onDismissNotification,
  [actions.REQUEST_ERROR]: onRequestError,
});
